"use client";

import styles from "./RequestForm.module.css";
import { useEffect, useRef, useState } from "react";
import useUiStore from "./store/uiStore"; // Zustand 스토어 import
 import apiService from "../services/api";

export default function RequestForm() {
    const { isFormVisible, hideForm } = useUiStore(); // 스토어에서 상태와 함수 가져오기
    const modalRef = useRef(null);
    const formRef = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    // 데스크탑에서는 항상 표시, 태블릿/모바일에서는 isFormVisible에 따라 표시
    const [isDesktop, setIsDesktop] = useState(false);

    const submitRequest = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const formData = new FormData(formRef.current);
            const requestData = {
                name: formData.get('user_name'),
                email: formData.get('user_email'),
                phone: formData.get('user_phone'),
                subject: formData.get('user_subject'),
                message: formData.get('user_message')
            };

            await apiService.submitRequest(requestData);
            
            alert("문의가 성공적으로 전송되었습니다!");
            formRef.current.reset();
            hideForm();
        } catch (error) {
            console.error("Request submission failed:", error);
            
            // 서버 엔드포인트가 아직 구현되지 않은 경우
            if (error.message.includes("404") || error.message.includes("Cannot POST /request")) {
                alert("서버가 아직 준비되지 않았습니다. 잠시 후 다시 시도해주세요.");
            } else {
                alert("문의 전송에 실패했습니다. 다시 시도해주세요.");
            }
        } finally {
            setIsSubmitting(false);
        }
    }; 

    const handleClickOutside = (event) => {
        // 데스크탑에서는 바깥 클릭 시 폼을 숨기지 않음
        if (isDesktop) return;
        
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            hideForm(); // 바깥 클릭 시 폼 숨기기
        }
    };

    useEffect(() => {
        const checkDesktop = () => {
            setIsDesktop(window.innerWidth > 1024);
        };
        
        checkDesktop();
        window.addEventListener('resize', checkDesktop);
        return () => window.removeEventListener('resize', checkDesktop);
    }, []);

    useEffect(() => {
        // 데스크탑이 아닐 때만 바깥 클릭 이벤트 처리
        if (!isDesktop && isFormVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFormVisible, isDesktop]);

    // 데스크탑이 아니고 폼이 보이지 않으면 렌더링하지 않음
    if (!isDesktop && !isFormVisible) {
        return null;
    }

    return (
        <div className={`${styles.overlay} ${isDesktop ? styles.desktopForm : ''}`}>
            <div ref={modalRef} className={`${styles.modal} ${isDesktop ? styles.desktopModal : ''}`}>
                {!isDesktop && (
                    <button
                        className={styles.closeBtn}
                        onClick={hideForm} // 닫기 버튼 클릭 시 폼 숨기기
                        aria-label="닫기"
                    >
                        ×
                    </button>
                )}
                <div className={styles.titleWrap}>
                    <h3>
                        <b>문의하기</b>
                    </h3>
                    <p>
                        아래의 폼을 작성해주시면 담당자가 1~2영업일 이내로
                        연락드리겠습니다.
                    </p>
                </div>
                <form
                    className={styles.formBody}
                    ref={formRef}
                  /*   onSubmit={submitRequest} */
                >
                    <div className={styles.inputBox}>
                        <label>성함</label>
                        <input
                            type="text"
                            name="user_name"
                            placeholder="성함"
                            required
                        />
                    </div>
                    <div className={styles.inputBox}>
                        <label>이메일 주소</label>
                        <input
                            type="email"
                            placeholder="이메일 주소"
                            required
                            name="user_email"
                        />
                    </div>
                    <div className={styles.inputBox}>
                        <label>핸드폰 번호</label>
                        <input
                            type="tel"
                            name="user_phone"
                            placeholder="연락처"
                            required
                        />
                    </div>
                    <div className={styles.inputBox}>
                        <label>문의 사항</label>
                        <select name="user_subject" required>
                            <option value="">문의 선택</option>
                            <option value="컨설팅 문의">교육프로그램 문의</option>
                            <option value="기업교육 문의">컨설팅 문의</option>
                            <option value="기타문의">정회원 문의</option>
                            <option value="제휴문의">기업멤버쉽 문의</option>
                            <option value="제휴문의">기타 문의</option>
                        </select>
                    </div>
                    <div className={styles.inputBox}>
                        <label>추가전달사항</label>
                        <textarea
                            name="user_message"
                            placeholder="추가전달사항"
                        />
                    </div>
                    <button 
                        type="submit" 
                        className={styles.submitBtn}
                        disabled={isSubmitting}
                        onClick={submitRequest}
                    >
                        {isSubmitting ? "전송 중..." : "보내기"}
                    </button>
                </form>
            </div>
        </div>
    );
}
